import { useMediaQuery, useTheme } from "@material-ui/core";

export const useGtXs = () => {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.up('sm'), { noSsr: true });
}
